import * as React from 'react';
import { CLASS_ACTIVITY_ITEM } from '../constants';
import './_ActivityHeader.scss';
import { IActivityHeaderProps } from './types';
import { ActivityActionsHOC } from '../../hocs/ActivityActionsHOC/ActivityActionsHOC';

export function ActivityHeader({
    activity,
    className: classNameOwn,
    content,
    icon,
    label, }: IActivityHeaderProps) {
    const className = CLASS_ACTIVITY_ITEM + '__header'
    return (
        <div className={`${className} ${classNameOwn || ''}`}>
            {icon}
            <span className={className + '-label'}>{label}</span>
            <ActivityActionsHOC activity={activity} />
            {content}
        </div>
    );
};
